import React from 'react';
import ReactDOM from 'react-dom';
import UeberUns from './UeberUns';

it('renders without crashing', () => {
  window.adjustSubmenu = () => {};

  const div = document.createElement('div');
  ReactDOM.render(<UeberUns />, div);
  ReactDOM.unmountComponentAtNode(div);
});



// WEBPACK FOOTER //
// ./src/ueber-uns/UeberUns.test.js